export default "https://sdk.cotreat.ai/chat-0a928fd3.svg";